import { formatDate } from "@/lib/formatters/DateFormatter";
import { Indent, Text } from "@stenajs-webui/core";

export const createRoutePairCustomerTargetStandardTableCell = (
  rowValue: string | number | undefined | null,
  isDateField: boolean = false,
  formatter?: (value: number) => string
) => {
  const formattedValue =
    rowValue === undefined || rowValue === null
      ? "-"
      : isDateField
      ? formatDate(rowValue.toString())
      : formatter && typeof rowValue === "number"
      ? formatter(rowValue)
      : rowValue;

  return (
    <Indent>
      <Text>{formattedValue}</Text>
    </Indent>
  );
};
